<template>
  <main class="container-fluid main-container listings-page" id="main-container">
    <!-- Hero Section -->
    <section class="row hero-section">
      <div class="col-xs-12 col-md-12 eoi-main-container">
        <p class="h4 listing-section-title text-primary">Listings</p>
        <h1 class="text-secondary main-title">
          Find a Rent Roll
        </h1>

        <!-- Search Filters with proper responsive layout -->
        <div class="row search-filters">
          <div class="col-xs-12 col-sm-6 col-md-3 filter-item">
            <select
              v-model="selectedState"
              class="form-control select-input"
            >
              <option value="">Select a State</option>
              <option v-for="state in geoLocations" :key="state.id" :value="state.id">
                {{ state.name }}
              </option>
            </select>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-3 filter-item">
            <select
              v-model="sortOption"
              class="form-control select-input"
              id="sortby"
              @change="onChange"
            >
              <option value="soldstatus" selected>Listing Status</option>
              <option value="region_asc">Region (A-Z)</option>
              <option value="region_desc">Region (Z-A)</option>
              <option value="price_asc">Price (Lowest first)</option>
              <option value="price_desc">Price (Highest first)</option>
            </select>
          </div>
          <div class="col-xs-6 col-sm-3 col-md-3 filter-item d-flex">
            <button
              @click="onClickSearch"
              class="btn search-btn bg-accent"
            >
              Search
            </button>
            <button
              v-if="selectedState || sortOption !== 'soldstatus'"
              @click="onClickClear"
              class="btn clear-btn bg-accent"
            >
              Clear
            </button>
          </div>
                
        </div>
      </div>
    </section>

    <!-- Listings Section -->
    <section class="row listings-section">
      <div class="col-xs-12 col-md-12 eoi-main-container">
        <!-- Loading Skeletons -->
        <div v-if="isLoading">
          <div class="skeleton-loader" v-for="n in 4" :key="n"></div>
        </div>

        <!-- Listings -->
        <div v-else-if="listings.length">
          <div v-for="listing in listings" :key="listing.reference" class="listing-item animate-pulse">
            <div class="listing-panel">
              <div class="panel-body">
                <div class="row panel-row">
                  <!-- Content Section - Full width on mobile, 8 cols on desktop -->
                  <div class="col-xs-12 col-lg-8 col-md-8 listing-content">
                    <!-- Title + Price -->
                    <div class="listing-header">
                      <h2 class="listing-title text-secondary font-bold">
                        {{ listing.region }}
                      </h2>
                      <p class="listing-price text-secondary">
                        {{ parseFloat(listing.price) ? '$'+listing.price : 'EOI' }} {{ listing.currency }}
                        <span v-if="listing.status === 'Sold' || listing.status === 'Under Contract'" class="status-label">
                          <router-link
                              :to="{
                              name: 'rent_roll_listings_show',
                              params: { id: listing.id }
                            }"
                          >
                             {{ listing.status }}
                          </router-link>
                        </span>
                      </p>
                      <span class="text-secondary font-bold gst-label">
                      {{ listing.include_gst ? 'Includes GST' : '' }}
                    </span>
                    </div>
                    

                    <!-- Mobile Stats Grid -->
                    <div class="row visible-xs-block visible-sm-block mobile-stats">
                      <div class="col-xs-6 col-sm-6 col-md-6 stat-item" v-for="[index, state] in states.entries()" :key="state.value" :class="{'odd': index % 2 === 0, 'even': index % 2 !== 0}">
                        <div class="stat-box text-secondary bg-white rounded-lg">
                          <div class="stat-icon text-secondary">
                            <i :class="[state.icon, 'text-secondary']"></i>
                          </div>
                          <span class="stat-label text-primary">{{ state.label }}</span>
                          <p class="stat-value">
                            <router-link
                              :to="{
                              name: 'rent_roll_listings_show',
                              params: { id: listing.id }
                            }"
                            >{{ listing[state.value] }}
                          </router-link>
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- Ref + Description -->
                    <div class="listing-details">
                      <!-- <p class="property-count">
                        <strong >Total Properties: 
                          <router-link
                              :to="{
                              name: 'rent_roll_listings_show',
                              params: { id: listing.id }
                            }"
                          >
                          {{
                                listing.total_properties
                              }}
                        </router-link>
                        </strong>
                        
                      </p> -->
                      <p class="reference"><strong>Ref: {{ listing.reference }}</strong> </p>
                      <p class="description ms-font-base md-font-xl">{{ listing.description }} </p>
                    </div>
                    <div class="gap-40 hidden-xs hidden-sm"></div>

                    <!-- View Details Button -->
                    <div class="view-details-container">
                      <router-link
                        :to="{ name: 'rent_roll_listings_show', params: { id: listing.id } }"
                      >
                        <button class="btn view-details-btn bg-accent">
                          Details
                        </button>
                      </router-link>
                    </div>
                  </div>

                  <!-- Desktop Stats Grid -->
                  <div class="hidden-xs hidden-sm">
                    <!-- Stats Grid -->
                    <div class="row desktop-stats text-secondary">
                      <div class="col-xs-6 col-sm-6 col-md-6 stat-item" v-for="[index, state] in states.entries()" :key="state.value" >
                        <div class="stat-box bg-white rounded-lg">
                          <div class="stat-icon">
                            <i :class="state.icon"></i>
                          </div>
                          <span class="stat-label text-primary">{{ state.label }}</span>
                          <p class="stat-value">
                            <router-link
                              :to="{
                              name: 'rent_roll_listings_show',
                              params: { id: listing.id }
                            }"
                            >{{ listing[state.value] }}
                          </router-link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="gap-40"></div>
          </div>
        </div>
        <div class="text-center" v-show="!listings.length">
          <img :src="no_result" class="no-results-image" alt="no result image" />
        </div>
        <div class="row" v-if="meta && meta.last_page > 1">
          <div class="col-md-12 text-center">
            <div class="paging">
              <Paginate
                  :page-count="meta.last_page"
                  :click-handler="pageChange"
                  :force-page="meta.current_page"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  container-class="pagination"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { geoLocations, listings } from "@/lib/axios";
import Paginate from "@/components/Paginate";
import Select from "@/components/Form/Select/Select.vue";
import no_result from '@/assets/images/no_result.png'

export default {
  components: {
    Paginate,
    Select
  },
  data() {
    return {
      listings: [],
      states: [
        {value: "residential", label: "Residential", icon: "fa fa-home"},
        {value: "commercial", label: "Commercial", icon: "fa fa-industry"},
        {value: "holiday", label: "Holiday", icon: "fa fa-plane"},
        {value: "strata", label: "Strata", icon: "fa fa-building"}
      ],
      meta: [],
      params: {
        page: 1,
        state_id: null,
        per_page: 8,
        sort_column: "active_date",
        sort_dir: "desc"
      },
      isLoading: false,
      selectedState: "",
      sortOption: "soldstatus",
      geoLocations: [],
      no_result: no_result
    };
  },
  computed: {
      // getGeoLocations() {
      //   return geoLocations;
      // }
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.params.state_id = this.$route.query.state;
    this.loadListings();
    this.getGeoLocations();
  },
  methods: {
    async loadListings() {
      this.isLoading = true;
      try {
        const { data } = await listings.get(`/listings`, {
          params: this.params
        });
        this.listings = data.data;
        this.meta = data.meta;
        this.isLoading = false;
      } catch (e) {
        console.log(e, "e");
        this.isLoading = false;
      }
    },
    getGeoLocations() {
      geoLocations.get(`/states/search`).then(response => {
        this.geoLocations = response.data.data;
      });
    },
    onClickClear() {
      this.selectedState = "";
      this.sortOption = "soldstatus";
      this.params = {
        ...this.params,
        state_id: null,
        sort_column: "active_date",
      };
      this.loadListings();
    },
    pageChange(page) {
      this.params = {
        ...this.params,
        page: page
      };
      this.loadListings();
    },
    handleDropdownChange(value, name) {
      this.params[name] = value;
    },
    onChange(e) {
      let value = e.target.value;
      if (value) {
        let sortArray = value.split("_");
        this.params = {
          ...this.params,
          sort_column: sortArray[0],
          sort_dir: sortArray[1]
        };
      } else {
        this.params = {
          ...this.params,
          sort_column: "active_date",
          sort_dir: null
        };
      }
    },
    onClickSearch(e) {
      e.preventDefault();
      this.params = {
        ...this.params,
        state_id: this.selectedState
      };
      this.loadListings();
    }
  }
};
</script>

<style scoped>
@media (min-width: 768px) {
  .eoi-main-container {
    padding-left: 10rem;
    padding-right: 10rem;
    
  }
  .main-title {
    font-size: 3.75em !important;
  }
  
  .listing-price {
    font-size: 2.25em !important;
  }
  .listing-title {
    font-size: 2.25em !important;
  }
  .stat-icon i {
    font-size: 2.25em !important;
  }
  .stat-value {
    font-size: 3.75em !important;
  }
  .listing-section-title {
    font-size: 25px !important;
  }
  .search-btn, .clear-btn {
    font-size: 20px !important;
  }
  .view-details-btn {
    font-size: 20px !important;
  }
  .stat-label {
    font-size: 20px !important;
  }
  .stat-value {
    font-size: 60px !important;
  }
  .main-container .row{
    margin-right: 0px !important;
  }
  .gst-label {
    font-size: 16px !important;
  }
}
@media (min-width: 1000px) {
  .view-details-container{
    position: absolute;
    bottom: 15px;
  }
}
.main-container {
  background: #f5f5f5;
  min-height: 100vh;
}

.hero-section {
  margin-left: 0;
  margin-right: 0;
  padding-bottom: 0;
}

.listing-section-title {
  font-size: 16pt;
}

.main-title {
  font-size: 30pt;
  margin-bottom: 56px;
  font-weight: 400;
}

.search-filters {
  max-width: 100%;
  margin-bottom: 40px;
}

.filter-item {
  margin-bottom: 15px;
  padding-left: 0px;
  font-size: 14pt !important;
}

.select-input {
  height: 42px;
  border-radius: 6px;
  color: #0c0b0b;
}

.search-btn, .clear-btn {
  border-radius: 6px;
  font-weight: 500;
  height: 40px;
  width: 100px;
  color: #0c0b0b;
  min-width: 100px;
  margin-right: 10px;
  font-size: 14pt;
}

.listings-section {
  padding-top: 32px;
}

.skeleton-loader {
  height: 350px;
  background: #e0e0e0;
  margin-bottom: 16px;
  border-radius: 20px;
}

.listing-panel {
  border-radius: 20px;
  border: 1px solid #ddd;
  background: rgb(34, 27, 53);
  overflow: hidden;
  transition: transform 0.3s ease;
  position: relative;
}
.listing-panel:hover {
  transform: scale(1.01);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.panel-body {
  padding: 24px;
}

.listing-header {
  margin-bottom: 8px;
}

.listing-title {
  font-size: 25pt !important;
  font-weight: normal;
  margin-bottom: 0px;
}

.listing-price {
  font-size: 25pt;
  font-weight: normal;
  margin-bottom: 0;
}

.status-label {
  font-size: 16pt;
  color: #ebecec;
  /* background: #cdcdcd; */
}

.mobile-stats {
  margin-bottom: 24px;
  margin-right: -7px !important;
}

.stat-item {
  margin-bottom: 15px;
  padding-left: 0px !important;
}
.row{
  /* margin-right: 0px !important; */
  margin-left: 0px !important;
}

.stat-box {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  text-align: left;
  padding: 15px;
}

.stat-icon {
  margin-bottom: 8px;
}

.stat-icon i {
  font-size: 25pt;
}

.stat-label {
  display: block;
  font-weight: 500;
  font-size: 14pt;
  margin-bottom: 15px;
}

.stat-value {
  font-size: 30pt;
  font-weight: bold;
  color: #9C65A9 !important;
  margin: 0;
}
.stat-value a:hover {
  color: #774582 !important;
}

.listing-details {
  margin-bottom: 24px;
}

.reference, .property-count {
  margin-bottom: 8px;
  color: #ccc !important;
  font-size: 16pt !important;
}

.description :deep(p) {
  color: #e0e0e0;
}

.view-details-container {
  margin-top: 24px;
  text-align: left;
}

.view-details-btn {
  font-weight: 500;
  font-size: 14pt;
  color: #000;
  border: none;
  transition: all 0.3s ease;
  display: inline-block;
  padding: 0.5em 1.25em;
  border-radius: 8px;
  
}

.view-details-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.view-details-btn-desktop {
  padding: 12px 32px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 20pt;
}
.no-results {
  text-align: center;
  color: #6c757d;
  min-height: 300px;
}

.no-results-image {
  margin: 0 auto;
  padding: 32px 0;
}

.pagination-container {
  text-align: center;
  margin-top: 48px;
}

.pagination-link {
  color: #221b35;
}
.bg-accent {
  --tw-bg-opacity: 1;
  background-color: rgb(204 212 233 / var(--tw-bg-opacity, 1));
}
.bg-accent:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(204 212 233 / var(--tw-bg-opacity, 1));
}
.pagination li a {
  color: #221b35;
  border-radius: 5px !important;

}
.listing-content {
  padding: 0px !important;
}
.panel-row {
  display: flex; 
  align-items: stretch;
}
.select-input {
  position: relative;
  padding-right: 3rem;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%23999" height="30" viewBox="0 0 24 24" width="30" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 2.5rem auto;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.text-description {
  font-size: 16px !important;
  color: #ffffff !important;
}
</style>
<style>
.listings-page .row{
  margin-right: 0px !important;
}
.stat-item.even{
  margin-right: 0px !important;
  padding-right: 0px !important;
}
</style>

